import sessionStorageEx from 'bundles/common/utils/sessionStorageEx';

const STORAGE_KEY_PREFIX = 'admin-coach:pending-action-completion';

export type AdminCoachActionCompletionContext = {
  actionId: string;
  messageId: string;
  sessionId: string;
};

const getStorageKey = (organizationId: string) => `${STORAGE_KEY_PREFIX}:${organizationId}`;

const isAdminCoachActionCompletionContext = (value: unknown): value is AdminCoachActionCompletionContext => {
  if (!value || typeof value !== 'object') return false;

  const context = value as Partial<AdminCoachActionCompletionContext>;
  return (
    typeof context.actionId === 'string' &&
    context.actionId.length > 0 &&
    typeof context.messageId === 'string' &&
    context.messageId.length > 0 &&
    typeof context.sessionId === 'string' &&
    context.sessionId.length > 0
  );
};

export const setPendingAdminCoachActionCompletion = (
  organizationId: string,
  context: AdminCoachActionCompletionContext
) => {
  if (!organizationId || !isAdminCoachActionCompletionContext(context) || !sessionStorageEx?.isAvailable()) return;

  sessionStorageEx.setItem(getStorageKey(organizationId), context, JSON.stringify);
};

export const getPendingAdminCoachActionCompletion = (
  organizationId: string
): AdminCoachActionCompletionContext | undefined => {
  if (!organizationId || !sessionStorageEx?.isAvailable()) return undefined;

  const storedValue = sessionStorageEx.getItem<unknown>(getStorageKey(organizationId), JSON.parse, undefined);
  return isAdminCoachActionCompletionContext(storedValue) ? storedValue : undefined;
};

export const clearPendingAdminCoachActionCompletion = (organizationId: string) => {
  if (!organizationId || !sessionStorageEx?.isAvailable()) return;

  sessionStorageEx.removeItem(getStorageKey(organizationId));
};
